import {qspost} from '@/plugins/axios'

/*
 * 登录
 * @constructor jack
 * */
export const login = (user_name, password) => qspost('/api/user/login', {user_name, password})

/*
 * 获取验证码
 * @constructor jack
 * */
export const sendCode = (tel,sms_type) =>qspost('/api/user/sms_code',{tel,sms_type})

/*
 * 注册
 * @constructor jack
 * */
export const register = (user_name,tel,sms_code,password,replay_password) =>qspost('/api/user/register',{user_name,tel,sms_code,password,replay_password})

/*
 * 修改密码
 * @constructor jack
 * */
export const foget = (user_name,tel,sms_code,password,replay_password) =>qspost('/api/user/forget',{user_name,tel,sms_code,password,replay_password})